/**
 * @file Writes an `AnalyticsView` as the Analytics page's canonical search
 * string, always in the order `tab`, `scope`, `period`, `status`,
 * `pastPromised`. Consumers: the page's view hook, which redirects any URL
 * whose search differs from this string and writes every view change through
 * it, and the Needs me link. The Orders keys are written only on `orders`,
 * `status` only when set and `pastPromised` only as `true` without a status,
 * as `analyticsView` reads them; the Needs me form
 * is `tab=orders&scope=self&period=ytd&pastPromised=true`. `project` is
 * written last, only on `projects` and only when set.
 */
import type { AnalyticsView } from './index.types';

export const analyticsViewSearch = (view: AnalyticsView): string => {
  const isOrders = view.tab === 'orders';
  return new URLSearchParams([
    ['tab', view.tab],
    ['scope', view.scope],
    ['period', view.period],
    ...(isOrders && view.status !== null ? [['status', view.status]] : []),
    ...(isOrders && view.status === null && view.pastPromised
      ? [['pastPromised', 'true']]
      : []),
    ...(view.tab === 'projects' && view.project !== null
      ? [['project', view.project]]
      : []),
  ]).toString();
};
